import { render } from "./HrAnnouncements.vue?vue&type=template&id=2483207c&scoped=true"
import script from "./HrAnnouncements.vue?vue&type=script&lang=js"
export * from "./HrAnnouncements.vue?vue&type=script&lang=js"

import "./HrAnnouncements.vue?vue&type=style&index=0&id=2483207c&scoped=true&lang=css"
import "@/assets/css/hr-page-shared.css?vue&type=style&index=1&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2483207c"]])

export default __exports__